<template>
  <section class="aso-email-step">
    <h2 class="aso-email-step__title">Digite seu e-mail.</h2>
    <p class="aso-email-step__text">Certifique-se de ter acesso ao seu e-mail.</p>
    <p class="aso-email-step__text">Vamos enviar um código para validá-lo.</p>

    <input
      class="aso-email-step__input"
      type="email"
      :value="email"
      placeholder="nome@example.com"
      :disabled="busy"
      @input="$emit('update:email', $event.target.value)"
    >

    <p class="aso-email-step__helper">Use o formato nome@example.com</p>

    <button
      type="button"
      class="aso-email-step__button aso-flow-button aso-flow-button--loud aso-flow-button--full aso-flow-button--uppercase"
      :disabled="busy || !canContinue"
      @click="$emit('continue')"
    >
      {{ busy ? 'Enviando...' : 'Continuar' }}
    </button>
  </section>
</template>

<script>
export default {
  name: 'AsoValidarEmailStep',
  props: {
    email: {
      type: String,
      default: '',
    },
    busy: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    canContinue() {
      return !!String(this.email || '').trim()
    },
  },
}
</script>



// WEBPACK FOOTER //
// AsoValidarEmailStep.vue?09149590